module.exports = __webpack_public_path__ + "static/media/indoramaCorporation.b449ed1e.svg";